import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';

const OrdinaryRow = (props) => {
	const {
		row, intl, remove, toggleProlongPopup, approveProlong, rejectProlong, can, expandedIds, toggleExpanded,
		toggleChangeDatePopup, toggleExpandedHistory, expandedHistoryIds
	} = props;

	return (
		<tr
			className={cn({ 'row-declined': !!row.is_rejected_prolong, 'is-out-progress': !row.is_in_progress })}
		>
			<td
				className={`id fixed-col ${cn({  'width-200': true })}` }
			>
				{
					!row.isNested &&
					<div>
						<p><span>{row.manager_email}</span></p>
						<p><span>{row.affiliate_email}</span></p>
						<p><span>Affiliate id: ({row.affiliate_id})</span></p>
						<p><span>{row.location_name}</span></p>
						<p><span>{row.offer_name}</span> </p>
						<p><span>{row.traffic_source}</span> </p>
						{row.campaign_id && <p><span>Campaign id: {row.campaign_id}</span> </p>}
					</div>
				}
				{
					row.idsCount > 1 && !row.isNested &&
					<p>
						<button
							className="btn width-100-p height-40 hover-pointer ui-btn ui-btn-cancel margin-top-5"
							onClick={toggleExpanded.bind(null, row.id)}
						>
							{expandedIds.includes(row.id) ? 'Сollect ↑' : 'Expand ↓'}
						</button>
					</p>
				}

				{
					!!row.ref_garant_id && !row.isHistoryRow && Number(row.row_number) === 1 &&
					<p>
						<button
							className="btn width-100-p height-40 hover-pointer ui-btn ui-btn-cancel margin-top-5"
							onClick={toggleExpandedHistory.bind(null, row.id)}
						>
							Task history {expandedHistoryIds.includes(row.id) ? 'collect ↑' : 'expand ↓'}
						</button>
					</p>
				}
			</td>
			<td className="width-100">
				<span>{row.id}</span>
			</td>
			<td className="width-100">
				<p>{row.starts_at}</p>
				<p>{row.ends_at}</p>
			</td>
			<td className="width-100">
				<span>{row.created_at}</span>
			</td>
			<td className="width-100">
				{row.start_leads_setting && row.start_leads_setting
					.sort((a, b) => a.start_leads_count > b.start_leads_count ? 1 : -1)
					.map((item, index) =>
						<p key={index}>{item.start_duration}: {item.start_leads_count}</p>
					)}
			</td>
			<td className="width-100">
				{
					!!Number(row.non_trash_leads_count) &&
					<span>
						{Math.floor(1000 * Number(row.approved_leads_count)/Number(row.non_trash_leads_count))/10}
					</span>
				}
			</td>
			<td className="width-100">
				<span>{Number(row.payout_amount)}$</span>
			</td>
			<td className="width-100">
				{
					!!row.isHistoryRow &&
					<span>{row.sids && row.sids.join(',')}</span>
				}
				{
					!row.isHistoryRow &&
					<span>{row.sid0}</span>
				}
			</td>
			<td className="width-100">
				<span>{row.duration && Object.values(row.duration)[0]}</span>
				<span> {row.duration && Object.keys(row.duration)[0]}</span>
			</td>
			<td
				className="width-100 hover-pointer"
				onClick={toggleChangeDatePopup.bind(null, row.id, row.sid0)}
			>
				{row.is_in_progress ? 'Действует' : 'Неактивен'}
			</td>
			<td className="width-100">
				<span>{row.non_trash_leads_count}</span>
			</td>
			<td className="width-100">
				<span>{Math.round(row.target_percent)}%</span>
			</td>
			<td className="width-100">
				{row.last_days_non_trash_leads_count}
			</td>
			<td className="width-100">
				<span>{row.prolong_reason}</span>
			</td>
			<td className="width-100">
				{row.prolonged_by_admin}
			</td>
			<td className="width-100">
				<span>{row.garant_expiration_comment}</span>
			</td>
			<td className="width-100">
				<a href={row.source_task_id} target="_blank">
					{row.source_task_id}
				</a>
			</td>
			<td className="fixed-col-right actions">
				{
					!row.isNested &&
					<div>
						{
							can('guarant_register_confirm_prolong') &&
							<p>
								<Link className="action_edit" to={`guarant-approve-requests/edit/${row.id}`}></Link>
								<a
									className="action_delete"
									onClick={e => { e.preventDefault(); return remove(row.id);}}
								/>
							</p>
						}
						<p className="display-flex-column margin-10-0">
							{
								(!row.prolong_type || row.is_rejected_prolong) &&
								<button
									className="approve-btn"
									onClick={toggleProlongPopup.bind(null, row.id)}
								>
									{intl('Запрос на продление')}
								</button>
							}
							{
								can('guarant_register_confirm_prolong')
								&& !!row.prolong_type
								&& !row.is_rejected_prolong
								&& <p className="display-flex margin-10-0">
									<button
										className="approve-btn"
										onClick={approveProlong.bind(null, row.id)}
									>
										Продлить
									</button>
									<button
										className="decline-btn margin-0-10"
										onClick={rejectProlong.bind(null, row.id)}
									>
										Отменить
									</button>
								</p>
							}
						</p>
					</div>
				}
			</td>
		</tr>
	);
}
;

export default OrdinaryRow;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/guarant-approve-register/list/components/table/row.js